import { render, staticRenderFns } from "./history-task-table.vue?vue&type=template&id=37e6da32&scoped=true&"
import script from "./history-task-table.vue?vue&type=script&lang=js&"
export * from "./history-task-table.vue?vue&type=script&lang=js&"
import style0 from "./history-task-table.vue?vue&type=style&index=0&id=37e6da32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e6da32",
  null
  
)

export default component.exports